import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const SyncButton: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;

  const { isSynced, isSharing, attendingMeeting } = rootStore.playerStore;
  const { enableShare, disableShareSync } = rootStore.tenantStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    if (!isSharing) enableShare();
    else disableShareSync();
  };

  return (
    <>
      <Button
        id="share"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 sharingSquareCorner toolbarButton",
          isSharing
            ? `${theme!.toolbarShareActiveBackground} ${
                theme!.toolbarShareActiveColor
              }`
            : `${theme!.toolbarIconColor}`
        )}
        disabled={isSynced || !attendingMeeting}
        color=""
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i
          className="fas fa-minus iconToolbarButton"
          style={{ position: "absolute", marginTop: "15px" }}
        ></i>
        <i className="fas fa-arrow-up iconToolbarButton"></i>

        <h6 className="textToolbarButton mb-0">{t("toolbar_share_button")}</h6>
      </Button>
    </>
  );
};

export default observer(SyncButton);
